exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header-line[data-v-71637094]{background:#eee;margin:20px 0;padding:5px 30px;display:flex;justify-content:space-between;align-items:center}.main-container[data-v-71637094]{padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-71637094&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/BaseContainer.vue
// module id = 574
// module chunks = 0